import {useState} from "react";
import {useSearchParams} from "react-router";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {
  DropdownAction,
  DropdownActionItem,
  DropdownItem,
  DropDownReactLink,
} from "@/components/quickActionsBar/DropdownAction.tsx";
import {DropdownDivider} from "@/components/quickActionsBar/DropdownDivider.tsx";
import {QuickActionsBar} from "@/components/quickActionsBar/QuickActionsBar.tsx";
import {GlobalAlertState} from "@/lib/types/alerting.ts";
import {ALERTS_ID_KEY, ALERTS_LEGACY_ID_KEY} from "@/pages/alerting/AlertsPage.utils.ts";
import {ShowAlertDetailsAction} from "@/pages/alerting/components/list/alertActions/AlertShowDetails.tsx";
import {AlertToggleIgnore} from "@/pages/alerting/components/list/alertActions/AlertToggleIgnore.tsx";
import {RecordCopyID} from "@/pages/alerting/components/list/alertActions/RecordCopyID.tsx";

interface AlertActionsProps {
  gas: GlobalAlertState;
}

export const AlertActions = ({gas}: AlertActionsProps) => {
  const {user} = useCurrentUserContext();
  const [queryParams, setQueryParams] = useSearchParams();

  const [showAlertDetailsAction, setShowAlertDetailsAction] = useState(
    queryParams.get(ALERTS_ID_KEY) === gas.id.toString() || queryParams.get(ALERTS_LEGACY_ID_KEY) === gas.id.toString()
  );

  const allItems: DropdownItem[] = [
    <RecordCopyID name="Alert" record={gas} />,
    <RecordCopyID name="Check" record={gas.service} />,
  ];

  const nonDeletedItems: DropdownItem[] = [
    ...(user?.has_write_access
      ? [<DropDownReactLink dataTestId="edit-check-dpd-btn" text="Edit Check" to={`/checks?pop=${gas.service.id}`} />]
      : []),
    <DropdownActionItem
      text="Alert Details"
      onClick={() => {
        setShowAlertDetailsAction(true);
      }}
    />,
    <DropDownReactLink text="Check Analysis" to={`/checks/${gas.service.id}`} />,
    <DropDownReactLink text="Real-Time Analysis" to={`/checks/${gas.service.id}/analysis`} />,
    ...(user?.has_write_access ? [<DropdownDivider />, <AlertToggleIgnore gas={gas} />] : []),
  ];

  return (
    <>
      <QuickActionsBar
        id={`alert-action-${gas.id}`}
        actions={[
          <DropdownAction
            id={`check-dd-${gas.id}`}
            items={gas.service_is_deleted ? allItems : nonDeletedItems.concat(allItems)}
          />,
        ]}
      />

      <ShowAlertDetailsAction
        gas={gas}
        show={showAlertDetailsAction}
        setShow={setShowAlertDetailsAction}
        queryParams={queryParams}
        setQueryParams={setQueryParams}
      />
    </>
  );
};
